import { Injectable } from '@angular/core';
import { interval, Subscription, throwError } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { JitsyService } from '../global-components/jitsi/jisti.service';
import {
  NzTimeSessionModalComponent
} from '../global-components/modals/time-session-modal/time-session-modal.component';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';


@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  socket$: WebSocketSubject<any>;
  subscription$: Subscription;
  ping$: Subscription;
  private statusPing = false;

  constructor(private auth: AuthService,
              private jitsyService: JitsyService,
              private modalService: NzModalService) {
  }
  init() {
    this.socket$ = webSocket({
      url: environment.webSocket,
    });

    this.subscription$ = this.socket$.pipe(
      /*map((message: any) => { return message.data }),*/
      catchError((error: any) => { return throwError(error) })
    ).subscribe(
      (data: any) => {
        if (data.Event === 'answer') {

        }

        if (data.Event === 'update') {
          this.jitsyService.update$.next(true);
        }

        if (data.Event === 'logout_warning') {
          this.timeSession(data?.Seconds);
        }

        if (data.Event === 'logout') {
          this.auth.logout();
        }

        if (data.Event === 'call_end') {
          this.jitsyService.closeCall$.next(true);
        }

        if (data.Event === 'decline') {
          this.jitsyService.hungUp$.next(true);
        }

        this.pingStart();
      },
      (error: any) => console.error(error),
      () => console.warn('Completed!')
    );
  }

  timeSession(time = 360) {
    time = Number(time.toFixed());
    const modal: NzModalRef = this.modalService.create({
      nzContent: NzTimeSessionModalComponent,
      nzMaskClosable: false,
      nzClosable: false,
      nzComponentParams: {
        time,
      },
      nzOnOk: () => new Promise(resolve => console.log(resolve)),
    });
  }

  pingStart() {
    if (this.statusPing) {
      return;
    }
    this.statusPing = true;
    this.ping$ = interval(10000).subscribe(x => {
      this.socket$.next({Event: 'Ping'});
    })
  }

  callStart(data: ResponseCallStart) {
    this.sendMessage({
      Event: "call_start",
      RecipientID: data.UserID,
      RecipientType: 'user',
      ChatID: data.ChatID,
      RoomCode: data.RoomCode
    });
  }

  destroy() {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }

  sendMessage(message: any) {
    this.socket$.next(message);
  }

}


export interface ResponseCallStart {
  ChatID: number; // общий у обоих
  UserID: number; // id кому звонят
  RoomCode: string;
}
